module.exports = {"id":"194876","name":"Maxim Kanunnikov","rating":"72","photo":"./data/images/photos/4/194876.png","club":{"name":"SKA Khabarovsk","logo":"./data/images/clubs/SKAKhabarovsk.png"},"positions":["BU","MD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximKanunnikov0.json
// module id = 2935
// module chunks = 0